<template>
  <Card :title="name">
    <template v-for="(b, i) in baseInfo">
      <Field
        :key="i"
        v-if="b.name == '其他'"
        v-model="b.remark"
        label="其他"
        :readonly="readonly"
        placeholder="请输入内容"
        show-word-limit
        type="textarea"
        maxlength="1000"
        rows="2"
      />
      <Field
        :key="i"
        v-else
        v-model="b.number"
        type="digit"
        :readonly="readonly"
        label-width="60%"
        :label="b.name"
        placeholder="请输入"
      >
        <template #button>天</template>
      </Field>
    </template>
  </Card>
</template>
<script>
import { Field } from "vant";
import Card from "@/components/trainingManual/card/Card.vue";
export default {
  name: "BaseInfo",
  props: {
    title: String,
    readonly: Boolean
  },
  data: function() {
    return {
      //   type: 1= 数字，2=文本
      // countWay:   0=不需要处理，1=数字相加，2=拼接
      // {
      //   name: "其他",
      //       number: 0,
      //     remark: "这里是描述，类型为2",
      //     type: 2,
      //     groupId: "mainDisease",
      //     countWay:2
      // }
      name: "一、基本情况",
      baseInfo: [
        { name: "事假", number: null, type: 1, countWay: 1 },
        { name: "病假", number: null, type: 1, countWay: 1 },
        { name: "迟到", number: null, type: 1, countWay: 1 },
        { name: "早退", number: null, type: 1, countWay: 1 },
        { name: "病人表扬", number: null, type: 1, countWay: 1 },
        { name: "病人投诉", number: null, type: 1, countWay: 1 },
        { name: "一般差错", number: null, type: 1, countWay: 1 },
        { name: "严重差错", number: null, type: 1, countWay: 1 },
        { name: "值中、夜班", number: null, type: 1, countWay: 1 },
        { name: "其他", number: null, remark: "", type: 2, countWay: 2 }
      ]
    };
  },
  components: { Card, Field }
};
</script>
<style lang="scss"></style>
